import { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth";
import { useSnackbar } from "notistack";
import { useAppContext } from "../../config/AppContext";
import { getOrgDataById, queryCollection } from "../../models/DataFunctions";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import { EasySwitch } from "../../textfields/EasySwitch";
import DropDownGPT03 from "../../dropdown/DropDownGTP03";
import TextField2T from "../../textfields/TextField2T";
import PrimaryButton from "../../buttons/PrimaryButton";
import { Divider, Space } from "antd";
import Column from "antd/es/table/Column";
import { useParams } from "react-router-dom";
import { InfoCell } from "./User";
import SecondaryButton from "../../buttons/SecondaryButton";
import Icon1 from "../../assets/icons/Icon";

function Org({ userData, orgData, handleLoginAs, navigateWorkspace }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const [actualOrgData, setActualOrgData] = useState(null);
  const [orgUsers, setOrgUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [experts, setExperts] = useState([]);
  const [masters, setMasters] = useState([]);
  const [role, setRole] = useState("");
  const [display_name, setDisplayName] = useState("");
  const [facturation, setFacturation] = useState(null);
  const [bridge_config, setBridgeConfig] = useState({});
  const [compteurs, setCompteurs] = useState(null);
  const [total_amount, setTotalAmount] = useState(0);

  const [engagement_itmes, setEngagementItems] = useState([
    { label: "Annuel", value: "year" },
    { label: "Mensuel", value: "month" },
    { label: "Abonnement à vie", value: "forever" },
    { label: "Rien", value: null },
  ]);
  const [bridge_fees_items, setBridgeFeesItems] = useState([
    { label: "0%", value: 0 },
    { label: "1%", value: 0.01 },
    { label: "1.5%", value: 0.015 },
    { label: "2%", value: 0.02 },
    { label: "2.5%", value: 0.025 },
    { label: "3%", value: 0.03 },
    { label: "3.5%", value: 0.035 },
    { label: "4%", value: 0.04 },
    { label: "4.5%", value: 0.045 },
    { label: "5%", value: 0.05 },
    { label: "5.5%", value: 0.055 },
    { label: "6%", value: 0.06 },
    { label: "6.5%", value: 0.065 },
    { label: "7%", value: 0.07 },
    { label: "7.5%", value: 0.075 },
    { label: "8%", value: 0.08 },
    { label: "8.5%", value: 0.085 },
    { label: "9%", value: 0.09 },
    { label: "9.5%", value: 0.095 },
    { label: "10%", value: 0.1 },
  ]);

  const [trial_period_items, setEngagementItemsss] = useState([
    { label: "0 jours", value: null },

    { label: "7 jours", value: 7 },
    { label: "14 jours", value: 14 },
    { label: "30 jours", value: 30 },
  ]);

  const [plans_itmes, setPlanItems] = useState([
    { label: "Starter", value: "starter" },
    { label: "Business", value: "business" },
    { label: "Premium", value: "premium" },
    { label: "Rien", value: null },
  ]);

  const plans_items_v2 = [
    { label: "Lighe", value: "lighe" },
    { label: "Basique", value: "basic" },
    { label: "Infiltro", value: "infiltro" },
    { label: "Audit", value: "audit" },
    { label: "BE", value: "be" },
  ];

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, resetAppStateLogin } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const users = [{ email: "dds@gmail.com" }, { email: "dsdds@gmail.com" }];

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    try {
      // Fetch user data

      const actual_org = await getOrgDataById(id);
      setFacturation(actual_org.facturation || {});
      setCompteurs(actual_org.compteurs || {});
      setBridgeConfig(actual_org.bridge || {});

      if (!actual_org) {
        handleClickVariant("Organisation non trouvée", "error");
        navigateWorkspace("/orgs");
      }
      const org_users =
        (await queryCollection("user", [
          { field: "org_id", operator: "==", value: actual_org.id },
        ])) || [];

      // Update state with fetched data

      setActualOrgData(actual_org);
      setOrgUsers(org_users);
      if (actual_org?.clients) {
        const clientsData = await Promise.all(
          actual_org.clients.map((client) => getOrgDataById(client.id))
        );
        setClients(clientsData);
      }

      if (actual_org?.experts) {
        const expertsData = await Promise.all(
          actual_org.experts.map((expert) => getOrgDataById(expert.id))
        );
        setExperts(expertsData);
      }

      if (actual_org?.masters_id) {
        const mastersData = await Promise.all(
          actual_org.masters_id.map((master) => getOrgDataById(master.id))
        );
        setMasters(mastersData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChangeStatsTest = async (checked) => {
    await updateDocDataFieldApi(
      actualOrgData.ref,
      "stats_test",
      checked,
      prefix
    );
    handleClickVariant("Statistiques de test", "success");
    handleFetchData();
  };

  const handleChangeInfiltreaEnv = async (checked) => {
    await updateDocDataFieldApi(
      actualOrgData.ref,
      "infiltrea.test_env",
      checked,
      prefix
    );
    handleFetchData();
  };

  const handleSave = async () => {
    await updateDocDataFieldApi(
      actualOrgData.ref,
      "facturation",
      facturation,
      prefix
    );
    await updateDocDataFieldApi(
      actualOrgData.ref,
      "compteurs",
      compteurs,
      prefix
    );
    await updateDocDataFieldApi(
      actualOrgData.ref,
      "bridge",
      bridge_config,
      prefix
    );
    handleClickVariant("Enregistré", "success");
    handleFetchData();
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [orgData]); // Dependency array ensures this runs when currentUser changes

  // Handle navigation to clients page
  const gotoOrgs = () => {
    navigateWorkspace("/admin/orgs");
  };

  // Handle an action (e.g., clicking on a DataGrid row)
  const doAction = () => {};

  if (loading || !currentUser || !actualOrgData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  return (
    <div className="flex flex-row w-full max-h-full overflow-auto  pb-28">
      <div className="flex flex-col h-fit flex-grow pl-4 w-full ">
        <Space y={20} />
        <div className="w-full flex flex-row h-full">
          <div
            className="flex flex-row w-full cursor-pointer"
            onClick={gotoOrgs}
          >
            <div className="text-h2 font-semibold text-pr bg-transparent">
              Orgs
            </div>
            <Icon1 icon_name="right" height="15px"></Icon1>
          </div>

          <div className="flex-grow flex-row-reverse flex w-full">
            <Space x={10} />
            <PrimaryButton
              className="w-fit"
              disabled={actualOrgData?.email === "william.bresso@gmail.com"}
              onClick={() => handleLoginAs(actualOrgData?.users_id[0])}
            >
              Login
            </PrimaryButton>
          </div>
        </div>
        <Space y={5} />
        <div className="text-hx font-semibold">{actualOrgData?.name}</div>
        <Space y={5} />
        <div className="rounded-xl h-auto w-full flex flex-row ">
          <img
            src={actualOrgData.logo}
            className="h-auto max-h-20 object-left w-auto object-contain rounded-xl"
          />
        </div>
        <Space y={30} />
        <div className="font-light text-h5">{actualOrgData?.logo}</div>
        {/* Displaying members and affiliates */}

        <div className="flex flex-col gap-1 mt-4">
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={actualOrgData?.stats_test}
              onChange={handleChangeStatsTest}
            ></EasySwitch>
            Statistiques de test
          </div>
        </div>

        <div className="flex flex-col gap-1 mt-4">
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            Abonnement plan
            <DropDownGPT03
              className={"w-c200"}
              items={plans_itmes}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  plan: e.value,
                })
              }
              value={facturation?.plan}
            ></DropDownGPT03>
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            Abonnement engagement
            <DropDownGPT03
              className={"w-c200"}
              items={engagement_itmes}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  engagement: e.value,
                })
              }
              value={facturation?.engagement}
            ></DropDownGPT03>
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.restricted}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  restricted: checked,
                })
              }
            ></EasySwitch>
            RESTRICTED
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.fake}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  fake: checked,
                })
              }
            ></EasySwitch>
            FAKE ACCOUNT
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.ambassador}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  ambassador: checked,
                })
              }
            ></EasySwitch>
            Ambassador
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.in_trial}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  in_trial: checked,
                })
              }
            ></EasySwitch>
            IN TRIAL
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.premium_trial}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  premium_trial: checked,
                })
              }
            ></EasySwitch>
            PREMIUM TRIAL
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <DropDownGPT03
              className={"w-c200"}
              label={"Trial period"}
              items={trial_period_items}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  trial_period: e.value,
                })
              }
              value={facturation?.trial_period}
            ></DropDownGPT03>
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <DropDownGPT03
              className={"w-c200"}
              label={"Bridge Fees"}
              items={bridge_fees_items}
              onChange={(e) =>
                setBridgeConfig({
                  ...bridge_config,
                  fees: e.value,
                })
              }
              value={bridge_config?.fees}
            ></DropDownGPT03>
          </div>
          <TextField2T
            value={bridge_config?.iban}
            label={"IBAN"}
            onChange={(e) =>
              setBridgeConfig({
                ...bridge_config,
                iban: e.target.value,
              })
            }
          ></TextField2T>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.test_env}
              onChange={(checked) =>
                setFacturation({ ...facturation, test_env: checked })
              }
            ></EasySwitch>
            Tarification TEST ENV
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.test_account}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  test_account: checked,
                })
              }
            ></EasySwitch>
            Compte TEST sans facturation
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <EasySwitch
              checked={facturation?.fake_account}
              onChange={(checked) =>
                setFacturation({
                  ...facturation,
                  fake_account: checked,
                })
              }
            ></EasySwitch>
            Compte FAKE
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.plan_subscription_id}
              label={"Plan Subscription ID"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  plan_subscription_id: e.target.value,
                })
              }
            ></TextField2T>
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.plan_subscription_item_id}
              label={"Plan Subscription Item ID"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  plan_subscription_item_id: e.target.value,
                })
              }
            ></TextField2T>
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.payment_method}
              label={"Moyen de paiement"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  payment_method: e.target.value,
                })
              }
            ></TextField2T>
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.appareils}
              label={"Nombre d'appareils"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  appareils: e.target.value,
                })
              }
            ></TextField2T>
          </div>

          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.stripe_client_id}
              label={"Stripe Client ID"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  stripe_client_id: e.target.value,
                })
              }
            ></TextField2T>
          </div>
          <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
            <TextField2T
              value={facturation?.LTV}
              label={"LTV"}
              onChange={(e) =>
                setFacturation({
                  ...facturation,
                  LTV: e.target.value,
                })
              }
            ></TextField2T>
          </div>
          <PrimaryButton
            className="w-fit"
            onClick={handleSave}
            disabled={
              facturation === actualOrgData.facturation &&
              compteurs === actualOrgData.compteurs &&
              bridge_config === actualOrgData.bridge
            }
          >
            Enregistrer
          </PrimaryButton>
          <div className="flex flex-col gap-1 mt-4">
            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              <EasySwitch
                checked={actualOrgData?.config?.ath?.new_model}
                onChange={(checked) => {
                  updateDocDataFieldApi(
                    actualOrgData.ref,
                    "config.ath.new_model",
                    checked,
                    prefix
                  );
                  setTimeout(() => {
                    handleFetchData();
                  }, 1000);
                }}
              ></EasySwitch>
              Nouveau modèle ATH
            </div>
            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              <EasySwitch
                checked={actualOrgData?.infiltrea?.visible}
                onChange={(checked) => {
                  updateDocDataFieldApi(
                    actualOrgData.ref,
                    "infiltrea.visible",
                    checked,
                    prefix
                  );
                  setTimeout(() => {
                    handleFetchData();
                  }, 1000);
                }}
              ></EasySwitch>
              Infiltrea VISIBLE
            </div>
            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              <EasySwitch
                checked={actualOrgData?.infiltrea?.connected}
                onChange={(checked) =>
                  updateDocDataFieldApi(
                    actualOrgData.ref,
                    "infiltrea.connected",
                    checked,
                    prefix
                  )
                }
              ></EasySwitch>
              Infiltrea connected
            </div>
            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              <EasySwitch
                checked={actualOrgData?.pennylane?.connected}
                onChange={(checked) =>
                  updateDocDataFieldApi(
                    actualOrgData.ref,
                    "pennylane.connected",
                    checked,
                    prefix
                  )
                }
              ></EasySwitch>
              Pennylane connected
            </div>
            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              <EasySwitch
                checked={actualOrgData?.stripe_connect?.connected}
                onChange={(checked) =>
                  updateDocDataFieldApi(
                    actualOrgData.ref,
                    "stripe_connect.connected",
                    checked,
                    prefix
                  )
                }
              ></EasySwitch>
              Stripe Express connected
            </div>
            <TextField2T
              value={total_amount}
              onChange={(e) => setTotalAmount(e.target.value)}
              label={"Total Amount"}
            ></TextField2T>

            <div className="flex flex-row gap-2 text-shadow_50 text-h3 items-center ">
              RESTRICTED
            </div>
          </div>
        </div>

        {/* Client contact information */}
      </div>

      <Divider orientation="vertical" />

      {/* Right Column: Fixed width */}
      <Column align="left" className="h-full max-w-c400 pl-2">
        <Space y={20} />
        <div className="text-h1 font-semibold">Informations</div>
        <Divider orientation="horizontal" />
        <Space y={5} />
        <Column align="left" className="w-full pr-2">
          <InfoCell title="Entreprise" data={actualOrgData?.name} />
          <InfoCell title="Email" data={actualOrgData?.email} />
          <InfoCell title="Téléphone" data={actualOrgData?.phone} />
          <InfoCell title="Adresse" data={actualOrgData?.infos?.adresse} />
          <InfoCell title="Ville" data={actualOrgData?.infos?.ville} />{" "}
          <InfoCell title="Postal" data={actualOrgData?.infos?.postam} />
        </Column>

        {/* Notes section */}
        <Space y={25} />
        <div className="text-h1 font-semibold">Notes</div>
        <Divider orientation="horizontal" />
        <Space y={5} />

        <div className="w-full flex flex-row-reverse px-3 py-1">
          <SecondaryButton>Enregistrer</SecondaryButton>
        </div>
      </Column>
    </div>
  );
}

export default Org;
